import Component from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/uni_modules/qiun-data-charts/components/qiun-loading/loading3.vue'
wx.createComponent(Component)